import { render, staticRenderFns } from "./select-remark-state.vue?vue&type=template&id=118ac5b0"
import script from "./select-remark-state.vue?vue&type=script&lang=ts"
export * from "./select-remark-state.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports